import { styled } from "@mui/material/styles";

const StyledSignIn = styled("div")`
  width: 100%;
  max-width: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > .sign-in__forgot {
    display: block;
    width: max-content;
    margin: -20px 0 32px auto;
  }

  & > .sign-in__btn {
    margin: auto 0 24px;
  }
`;

const StyledSignInHeadings = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    max-width: 400px;
  }
`;

const StyledSignInFields = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;

export { StyledSignIn, StyledSignInHeadings, StyledSignInFields };
